module.exports = "/_next/static/images/9651b908c07b844133ce30ee1dd6ea95-phone-xs.png";